export const TrendingNavBarHeight = 39;
